/**
 * EasypostLogo/index.js
 * desc: Easypost product logo
 * note: renders an accessible button (aria-label) when given an onClick handler; otherwise a static figure
 */
'use strict';

import IconButton from '../IconButton';


const EasypostLogo = (props) => (
    <IconButton baseClassName="easypost logo" label="EasyPost" tooltip={ null } { ...props }>
        <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M245.962 302.33C249.335 304.263 252.255 304.757 256.121 304.757C259.534 304.757 263.4 303.811 266.32 302.33L482.282 177.631V144.605C482.282 132.473 475.99 121.327 465.79 115.487L272.613 4.35954C267.801 1.48059 261.961 0 256.121 0C250.322 0 244.975 1.48059 239.628 4.35954L46.4923 115.487C36.2926 121.327 30 132.473 30 144.605V367.353C30 379.034 36.2926 390.179 46.4923 396.02L239.628 507.64C244.975 510.519 250.322 512 256.121 512C261.961 512 267.801 510.519 272.613 507.64L465.79 396.02C475.99 390.179 482.282 379.034 482.282 367.353V334.369L266.32 459.11C263.894 460.549 260.028 461.536 256.121 461.536C252.748 461.536 249.335 461.043 245.962 459.11L143.06 399.392V347.489L245.962 406.672C249.335 408.605 252.748 409.592 256.121 409.592C260.028 409.592 263.4 408.605 266.32 406.672L482.282 281.972V229.534L266.32 354.768C263.4 356.208 259.534 357.195 256.121 357.195C252.255 357.195 249.335 356.701 245.962 354.768L143.06 295.051V242.654L245.962 302.33Z" fill="#164DFF" />
        </svg>
    </IconButton>
);


export default EasypostLogo;
